import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed, ref } from "vue";
import dayjs from "dayjs";
import {
  ILineDemandSurvey,
  ILineDemandSurveyAnswer,
} from "@/domain/entities/survey";
import BaseButton from "../shared/button/base/BaseButton.vue";
import ScrollTopControl from "@/components/shared/ScrollTopControl.vue";


const __default__ = {
  name: "RouteDemandSurveyDetail",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  lineDemandSurveyAnswer: {
    type: Object as PropType<ILineDemandSurveyAnswer>,
    required: true,
  },
  lineDemandSurvey: {
    type: Object as PropType<ILineDemandSurvey>,
  },
},
  emits: ["onClickEditBtn", "onClickDeleteBtn", "onClickReceiveResultBtn", "onClickMap"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const scrollContainer = ref<HTMLElement>();

const surveyUseDuration = computed(() => {
  if (!props.lineDemandSurvey) return "";

  const { useBeginDtm, useEndDtm } = props.lineDemandSurvey;

  return `${dayjs(useBeginDtm).format("YYYY-MM-DD")}~${dayjs(useEndDtm).format(
    "YYYY-MM-DD"
  )}`;
});

const emitOnClickEditBtn = () => {
  emit("onClickEditBtn");
};

const emitOnClickDeleteBtn = () => {
  emit("onClickDeleteBtn");
};

const __returned__ = { props, emit, scrollContainer, surveyUseDuration, emitOnClickEditBtn, emitOnClickDeleteBtn, BaseButton, ScrollTopControl }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})